import { Auth } from 'Shared/auth';

onDomReady(() => {
   if (
      !Auth.isLoggedIn() &&
      document.querySelector('#errorName').textContent == 'e403' &&
      !App.disableAutoLogin
   ) {
      Auth.required({
         message: '',
         locked: false,
         ignoreSSO: App.onManage,
         stayInWindow: true,
         register: true,
         onAuthorize: () => {
            window.location.reload();
         },
      });
   }
});
